import { CookieStorage } from "@front/services/storage";
import { createPlugin } from "@front/utils/alpine";

export default createPlugin((vm) => {

    vm.store('display', {

        _display: vm.$persist(
            vm.$defaults('display')
        ).using(CookieStorage),

        get hidePrices () {
            return this._display.hidePrices;
        },

        set hidePrices (val: boolean) {
            this._display.hidePrices = val;
        },

        get showFeatures () {
            return this._display.showFeatures;
        },

        set showFeatures (val: boolean) {
            this._display.showFeatures = val;
        }

    } as { _display: {
        hidePrices: boolean,
        showFeatures: boolean,
    } });

});
